<template>
    <Transition>
        <a
            v-if="currentScroll > scrollAmount"
            href="javascript:void(0);"
            class="back-to-top"
            :style="{ bottom: bottomPosition }"
            @click="scrollToTop"
            ><i class="fa fa-angle-up"></i
        ></a>
    </Transition>
</template>

<script>
/**
 * @name PurchasesList
 * @description Button component to trigger scroll to top for long report, based on Git issue apps#4584,
 * @optional scrollAmount, amount of scroll require to show the scroll to top button
 * @see apps/application/views/staff/patient/soap/index.php
 * @see apps/assets/css/style.css
 */

export default {
    name: "scrollToTop",
    props: {
        targetSelector: {
            type: String,
            default: null // If null, will use window
        },
        scrollAmount: {
            type: Number,
            default: 50
        },
        isSmooth: {
            type: Boolean,
            default: false
        },
        bottom: {
            type: [Number, String],
            default: 40
        }
    },
    data() {
        return {
            currentScroll: 0,
            targetElement: null
        }
    },
    mounted() {
        this.targetElement = this.targetSelector
            ? document.getElementById(this.targetSelector)
            : window;

        if (this.targetElement) {
            // add window or target element event listener for scroll
            this.targetElement.addEventListener('scroll', this.getCurrentScroll);
        }
    },
    beforeDestroy() {
        // will cause performance issue if it is not remove, reference: https://stackoverflow.com/a/62865679
        if (this.targetElement) {
            this.targetElement.removeEventListener('scroll', this.getCurrentScroll);
        }
    },
    computed: {
        bottomPosition() {
            // Handle both number and string inputs (e.g., '40px' or 40)
            return typeof this.bottom === 'number' 
                ? `${this.bottom}px`
                : this.bottom;
        }
    },
    methods: {
        scrollToTop() {
            if (this.targetElement === window) {
                window.scrollTo({
                    top: 0,
                    behavior: this.isSmooth ? "smooth" : "instant"
                });
            } else {
                this.targetElement.scrollTo({
                    top: 0,
                    behavior: this.isSmooth ? "smooth" : "instant"
                });
            }
        },
        getCurrentScroll() {
            this.currentScroll = this.targetElement === window 
                ? window.scrollY
                : this.targetElement.scrollTop;
        }
    }
}
</script>

<style scoped>
a.back-to-top {
    width: 50px;
    height: 50px;
    position: fixed;
    z-index: 999;
    right: 40px;
    text-align: center;
    font-size: 24px;
    line-height: 48px;
    color: rgba(255, 255, 255);
    background-color: rgba(190, 212, 232, 0.6);
    border-radius: 3px;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
}

a:hover.back-to-top {
    background-color: rgba(103, 143, 53, 0.6);
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2);
}

.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease !important;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
